import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import ProjectModal from './ProjectModal';
import CalendarModal from './CalendarModal';

const HeroSection = ({ openCalendarModal }) => {
  const services = ['Web Apps', 'Mobile Apps', 'Websites', 'AI-Powered Digital Innovation', 'Ideas that come to life'];
  const [currentServiceIndex, setCurrentServiceIndex] = useState(0);
  const [isProjectModalOpen, setIsProjectModalOpen] = useState(false);
  const [isCalendarModalOpen, setIsCalendarModalOpen] = useState(false);

  // Allow parent to trigger calendar modal
  useEffect(() => {
    if (openCalendarModal) {
      setIsCalendarModalOpen(true);
    }
  }, [openCalendarModal]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentServiceIndex((prevIndex) => (prevIndex + 1) % services.length);
    }, 5000); // Change every 5 seconds

    return () => clearInterval(interval);
  }, [services.length]);

  return (
    <section id="home" className="relative min-h-screen overflow-hidden pt-20">
      {/* Video Background */}
      <div className="absolute inset-0 z-0">
        <video
          autoPlay
          loop
          muted
          playsInline
          className="absolute inset-0 w-full h-full object-cover"
        >
          <source src="https://customer-assets.emergentagent.com/job_creative-studio-146/artifacts/giv01pvn_sanjuanventures_An_East_african_young_woman_with_long_neatly__51495228-3c7b-474a-9f45-329a54ade807_2.mp4" type="video/mp4" />
        </video>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 py-16 lg:py-24">
        <div className="flex justify-center items-center">
          {/* Center Content */}
          <div className="space-y-8 animate-fade-in max-w-5xl text-center">
            {/* Main Identity Block */}
            <div className="space-y-4">
              <div className="min-h-[300px] flex items-center justify-center">
                <h1 className="text-5xl lg:text-7xl font-bold leading-tight text-center drop-shadow-2xl">
                  <span className="text-white">
                    Let there be...
                  </span>
                  <br />
                  <span 
                    key={currentServiceIndex}
                    className="bg-gradient-to-r from-pink-400 via-violet-400 to-yellow-400 bg-clip-text text-transparent animate-cycle-fade drop-shadow-lg"
                  >
                    {services[currentServiceIndex]}
                  </span>
                </h1>
              </div>
            </div>

            {/* Brand Statement */}
            <div className="max-w-3xl mx-auto">
              <p className="text-lg text-white/90 leading-relaxed animate-light-up drop-shadow-lg" style={{ animationDelay: '1s' }}>
                Let There Be builds modern websites, mobile applications, and AI-powered business systems for companies that want to turn ideas into digital reality — from design, to development, to deployment.
              </p>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-wrap gap-4 pt-6 justify-center">
              <Button 
                size="lg"
                onClick={() => setIsProjectModalOpen(true)}
                className="bg-gradient-to-r from-pink-600 via-red-500 to-violet-600 text-white font-bold px-10 py-7 text-lg rounded-full hover:shadow-2xl hover:scale-105 transition-all duration-300 hover:shadow-pink-500/50 w-[260px] h-[64px]"
              >
                Start a Project
              </Button>
              <button 
                onClick={() => setIsCalendarModalOpen(true)}
                className="relative px-10 py-7 text-lg rounded-full font-bold hover:shadow-xl transition-all duration-300 hover:scale-105 bg-white w-[260px] h-[64px] flex items-center justify-center"
              >
                <span className="absolute inset-0 rounded-full p-[2px] bg-gradient-to-r from-pink-600 to-violet-600">
                  <span className="flex w-full h-full items-center justify-center rounded-full bg-white"></span>
                </span>
                <span className="relative z-10 bg-gradient-to-r from-pink-600 to-violet-600 bg-clip-text text-transparent">Book a Discovery Call</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Modals */}
      <ProjectModal isOpen={isProjectModalOpen} onClose={() => setIsProjectModalOpen(false)} />
      <CalendarModal isOpen={isCalendarModalOpen} onClose={() => setIsCalendarModalOpen(false)} />
    </section>
  );
};

export default HeroSection;